<template>
  <div></div>
</template>

<script>
export default {
  data() {
    window.$this = this;
    return {};
  },
  mounted() {
    this.ssoAuth();
  },
  methods: {
    ssoAuth() {
      this.osg.ajax('/privatization/yuhongfangshui/ssoAuth.do', {}, res => {
        window.location.href = res.data.data;
      });
    }
  }
};
</script>
